module.exports = __webpack_public_path__ + "static/img/4.7b7c45f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/version/04/4.png
// module id = qZu3
// module chunks = 1